/**
 * Returns a human-readable string representing how long ago a date was
 * @param date The date to check
 * @returns A string like "2 minutes ago" or "3 days ago"
 */
export function timeAgo(date: Date | string | number): string {
  const now = new Date();
  const past = new Date(date);
  const diffInSeconds = Math.floor((now.getTime() - past.getTime()) / 1000);

  // Define time intervals in seconds
  const intervals = {
    year: 31536000,
    month: 2592000,
    day: 86400,
    hour: 3600,
    minute: 60,
    second: 1
  };

  for (const [unit, secondsInUnit] of Object.entries(intervals)) {
    const difference = Math.floor(diffInSeconds / secondsInUnit);

    if (difference >= 1) {
      return `${difference} ${unit}${difference === 1 ? '' : 's'} ago`;
    }
  }

  return 'just now';
}